import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { Helper, SideNavService } from '@usimweb/core/services';
import { Contacts, Env } from '@usimweb/core/models';

import { skip } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ColorInjector } from '../ColorInjector';

@Component({
    selector: 'usimweb-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent extends ColorInjector implements OnInit, OnChanges {
  @Input() app = '';
  @Input() user = '';

  @Output() logoutEvent: EventEmitter<any> = new EventEmitter<any>();

  private cms: string = 'https://ultrasimweb.basf.com/';
  private app_home: string = '';

  public fullName: string = '';
  public initial: string = '';
  public contacts: number = 0;

  constructor(@Inject('environment') environment: Env, private sideNavService: SideNavService, private cd: ChangeDetectorRef, private router: Router) {
    super(environment);
  }

  ngOnInit(): void {
    this.app_home = 'https://ultrasimweb.basf.com/' + this.app.toLocaleLowerCase() + '/';
    this.sideNavService.updateCallback.pipe(skip(1)).subscribe((contacts: Contacts[]) => {
      this.contacts = contacts.length;
      this.cd.detectChanges();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.user && changes['user']) {
      this.fullName = this.user;
      this.initial = Helper.StringFormatter.getInitial(this.user || '');
    }
  }

  public mailMe() {
    const mailText = 'mailto:ultrasimweb@basf.com';
    window.location.href = mailText;
  }

  public openSidebar() {
    this.sideNavService.toggle();
  }

  public logout() {
    this.logoutEvent.emit();
  }

  public openCredits() {
    this.router.navigate(['app/credits']);
  }

  public openContacts() {
    this.router.navigate(['app/contacts']);
  }

  public openCms() {
    window.open(this.cms);
  }

  public openHomeApp() {
    window.open(this.app_home);
  }
}
